export default __webpack_public_path__ + "static/barn-demolition-banner-c91c9212f959978c664f5c1ea49216b3.jpg";